import * as XLSX from "xlsx";
import * as ExcelJS from "exceljs";
import * as Dfns from "date-fns/fp";
import {
  BudgetIntakeRowInternal,
  BudgetIntakeRowInternal as BudgetIntakeRowInternalExcel,
} from "@blisspointmedia/bpm-types/dist/BudgetIntakeTool";

const excelColumnLetters = [
  "A",
  "B",
  "C",
  "D",
  "E",
  "F",
  "G",
  "H",
  "I",
  "J",
  "K",
  "L",
  "M",
  "N",
  "O",
  "P",
  "Q",
  "R",
  "S",
  "T",
  "U",
  "V",
  "W",
  "X",
  "Y",
  "Z",
  "AA",
  "AB",
  "AC",
  "AD",
  "AE",
  "AF",
  "AG",
  "AH",
  "AI",
  "AJ",
  "AK",
  "AL",
  "AM",
  "AN",
  "AO",
  "AP",
  "AQ",
  "AR",
  "AS",
  "AT",
  "AU",
  "AV",
  "AW",
  "AX",
  "AY",
  "AZ",
  "BA",
  "BB",
  "BC",
  "BD",
  "BE",
  "BF",
  "BG",
  "BH",
  "BI",
  "BJ",
  "BK",
  "BL",
  "BM",
  "BN",
  "BO",
  "BP",
  "BQ",
  "BR",
  "BS",
  "BT",
  "BU",
  "BV",
  "BW",
  "BX",
  "BY",
  "BZ",
  "CA",
  "CB",
  "CC",
  "CD",
  "CE",
  "CF",
  "CG",
  "CH",
  "CI",
  "CJ",
  "CK",
  "CL",
  "CM",
  "CN",
  "CO",
  "CP",
  "CQ",
  "CR",
  "CS",
  "CT",
  "CU",
  "CV",
  "CW",
  "CX",
  "CY",
  "CZ",
  "DA",
  "DB",
  "DC",
  "DD",
  "DE",
  "DF",
  "DG",
  "DH",
  "DI",
  "DJ",
  "DK",
  "DL",
  "DM",
  "DN",
  "DO",
  "DP",
  "DQ",
  "DR",
  "DS",
  "DT",
  "DU",
  "DV",
  "DW",
  "DX",
  "DY",
  "DZ",
  "EA",
  "EB",
  "EC",
  "ED",
  "EE",
  "EF",
  "EG",
  "EH",
  "EI",
  "EJ",
  "EK",
  "EL",
  "EM",
  "EN",
  "EO",
  "EP",
  "EQ",
  "ER",
  "ES",
  "ET",
  "EU",
  "EV",
  "EW",
  "EX",
  "EY",
  "EZ",
  "FA",
  "FB",
  "FC",
  "FD",
  "FE",
  "FF",
  "FG",
  "FH",
  "FI",
  "FJ",
  "FK",
  "FL",
  "FM",
  "FN",
  "FO",
  "FP",
  "FQ",
  "FR",
  "FS",
  "FT",
  "FU",
  "FV",
  "FW",
  "FX",
  "FY",
  "FZ",
  "GA",
  "GB",
  "GC",
  "GD",
  "GE",
  "GF",
  "GG",
  "GH",
  "GI",
  "GJ",
  "GK",
  "GL",
  "GM",
  "GN",
  "GO",
  "GP",
  "GQ",
  "GR",
  "GS",
  "GT",
  "GU",
  "GV",
  "GW",
  "GX",
  "GY",
  "GZ",
  "HA",
  "HB",
  "HC",
  "HD",
  "HE",
  "HF",
  "HG",
  "HH",
  "HI",
  "HJ",
  "HK",
  "HL",
  "HM",
  "HN",
  "HO",
  "HP",
  "HQ",
  "HR",
  "HS",
  "HT",
  "HU",
  "HV",
  "HW",
  "HX",
  "HY",
  "HZ",
  "IA",
  "IB",
  "IC",
  "ID",
  "IE",
  "IF",
  "IG",
  "IH",
  "II",
  "IJ",
  "IK",
  "IL",
  "IM",
  "IN",
  "IO",
  "IP",
  "IQ",
  "IR",
  "IS",
  "IT",
  "IU",
  "IV",
  "IW",
  "IX",
  "IY",
  "IZ",
  "JA",
  "JB",
  "JC",
  "JD",
  "JE",
  "JF",
  "JG",
  "JH",
  "JI",
  "JJ",
  "JK",
  "JL",
  "JM",
  "JN",
  "JO",
  "JP",
  "JQ",
  "JR",
  "JS",
  "JT",
  "JU",
  "JV",
  "JW",
  "JX",
  "JY",
  "JZ",
  "KA",
  "KB",
  "KC",
  "KD",
  "KE",
  "KF",
  "KG",
  "KH",
  "KI",
  "KJ",
  "KK",
  "KL",
  "KM",
  "KN",
  "KO",
  "KP",
  "KQ",
  "KR",
  "KS",
  "KT",
  "KU",
  "KV",
  "KW",
  "KX",
  "KY",
  "KZ",
  "LA",
  "LB",
  "LC",
  "LD",
  "LE",
  "LF",
  "LG",
  "LH",
  "LI",
  "LJ",
  "LK",
  "LL",
  "LM",
  "LN",
  "LO",
  "LP",
  "LQ",
  "LR",
  "LS",
  "LT",
  "LU",
  "LV",
  "LW",
  "LX",
  "LY",
  "LZ",
  "MA",
  "MB",
  "MC",
  "MD",
  "ME",
  "MF",
  "MG",
  "MH",
  "MI",
  "MJ",
  "MK",
  "ML",
  "MM",
  "MN",
  "MO",
  "MP",
  "MQ",
  "MR",
  "MS",
  "MT",
  "MU",
  "MV",
  "MW",
  "MX",
  "MY",
  "MZ",
  "NA",
  "NB",
  "NC",
  "ND",
  "NE",
  "NF",
  "NG",
  "NH",
  "NI",
  "NJ",
  "NK",
  "NL",
  "NM",
  "NN",
  "NO",
  "NP",
  "NQ",
  "NR",
  "NS",
  "NT",
  "NU",
  "NV",
  "NW",
  "NX",
  "NY",
  "NZ",
  "OA",
  "OB",
  "OC",
  "OD",
  "OE",
  "OF",
  "OG",
  "OH",
  "OI",
  "OJ",
  "OK",
  "OL",
  "OM",
  "ON",
  "OO",
  "OP",
  "OQ",
  "OR",
  "OS",
  "OT",
  "OU",
  "OV",
  "OW",
  "OX",
  "OY",
  "OZ",
  "PA",
  "PB",
  "PC",
  "PD",
  "PE",
  "PF",
  "PG",
  "PH",
  "PI",
  "PJ",
  "PK",
  "PL",
  "PM",
  "PN",
  "PO",
  "PP",
  "PQ",
  "PR",
  "PS",
  "PT",
  "PU",
  "PV",
  "PW",
  "PX",
  "PY",
  "PZ",
  "QA",
  "QB",
  "QC",
  "QD",
  "QE",
  "QF",
  "QG",
  "QH",
  "QI",
  "QJ",
  "QK",
  "QL",
  "QM",
  "QN",
  "QO",
  "QP",
  "QQ",
  "QR",
  "QS",
  "QT",
  "QU",
  "QV",
  "QW",
  "QX",
  "QY",
  "QZ",
  "RA",
  "RB",
  "RC",
  "RD",
  "RE",
  "RF",
  "RG",
  "RH",
  "RI",
  "RJ",
  "RK",
  "RL",
  "RM",
  "RN",
  "RO",
  "RP",
  "RQ",
  "RR",
  "RS",
  "RT",
  "RU",
  "RV",
  "RW",
  "RX",
  "RY",
  "RZ",
  "SA",
  "SB",
  "SC",
  "SD",
  "SE",
  "SF",
  "SG",
  "SH",
  "SI",
  "SJ",
  "SK",
  "SL",
  "SM",
  "SN",
  "SO",
  "SP",
  "SQ",
  "SR",
  "SS",
  "ST",
  "SU",
  "SV",
  "SW",
  "SX",
  "SY",
  "SZ",
  "TA",
  "TB",
  "TC",
  "TD",
  "TE",
  "TF",
  "TG",
  "TH",
  "TI",
  "TJ",
  "TK",
  "TL",
  "TM",
  "TN",
  "TO",
  "TP",
  "TQ",
  "TR",
  "TS",
  "TT",
  "TU",
  "TV",
  "TW",
  "TX",
  "TY",
  "TZ",
  "UA",
  "UB",
  "UC",
  "UD",
  "UE",
  "UF",
  "UG",
  "UH",
  "UI",
  "UJ",
  "UK",
  "UL",
  "UM",
  "UN",
  "UO",
  "UP",
  "UQ",
  "UR",
  "US",
  "UT",
  "UU",
  "UV",
  "UW",
  "UX",
  "UY",
  "UZ",
  "VA",
  "VB",
  "VC",
  "VD",
  "VE",
  "VF",
  "VG",
  "VH",
  "VI",
  "VJ",
  "VK",
  "VL",
  "VM",
  "VN",
  "VO",
  "VP",
  "VQ",
  "VR",
  "VS",
  "VT",
  "VU",
  "VV",
  "VW",
  "VX",
  "VY",
  "VZ",
  "WA",
  "WB",
  "WC",
  "WD",
  "WE",
  "WF",
  "WG",
  "WH",
  "WI",
  "WJ",
  "WK",
  "WL",
  "WM",
  "WN",
  "WO",
  "WP",
  "WQ",
  "WR",
  "WS",
  "WT",
  "WU",
  "WV",
  "WW",
  "WX",
  "WY",
  "WZ",
  "XA",
  "XB",
  "XC",
  "XD",
  "XE",
  "XF",
  "XG",
  "XH",
  "XI",
  "XJ",
  "XK",
  "XL",
  "XM",
  "XN",
  "XO",
  "XP",
  "XQ",
  "XR",
  "XS",
  "XT",
  "XU",
  "XV",
  "XW",
  "XX",
  "XY",
  "XZ",
  "YA",
  "YB",
  "YC",
  "YD",
  "YE",
  "YF",
  "YG",
  "YH",
  "YI",
  "YJ",
  "YK",
  "YL",
  "YM",
  "YN",
  "YO",
  "YP",
  "YQ",
  "YR",
  "YS",
  "YT",
  "YU",
  "YV",
  "YW",
  "YX",
  "YY",
  "YZ",
  "ZA",
  "ZB",
  "ZC",
  "ZD",
  "ZE",
  "ZF",
  "ZG",
  "ZH",
  "ZI",
  "ZJ",
  "ZK",
  "ZL",
  "ZM",
  "ZN",
  "ZO",
  "ZP",
  "ZQ",
  "ZR",
  "ZS",
  "ZT",
  "ZU",
  "ZV",
  "ZW",
  "ZX",
  "ZY",
  "ZZ",
];

const transformKeyToTitleCase = (key: string): string => {
  return key
    .split("_")
    .map((word, index) =>
      index === 0 ? word.charAt(0).toUpperCase() + word.slice(1) : word.toLowerCase()
    )
    .join(" ");
};

export const exportToExcelWithDropDown = async (
  rows: BudgetIntakeRowInternalExcel[],
  company: string,
  customSegmentList: string[],
  budgetIntakeSelectorOptionsPull: {}
): Promise<void> => {
  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet(company);

  const segmentHeader = customSegmentList.map(key => ({
    header: transformKeyToTitleCase(key),
    key: key,
  }));

  const hiddenHeaders = [
    { header: "KPI", key: "kpi" },
    { header: "KPI Source", key: "source" },
    { header: "Campaign (Platform)", key: "campaign_platform" },
  ];
  let headerRowOptions = [
    { header: "id", key: "id" },
    { header: "Start Date", key: "start_date" },
    { header: "End Date", key: "end_date" },
    ...segmentHeader,
    { header: "Goal Name", key: "goal_name" },
    { header: "Goal Value", key: "goal_value" },
    ...hiddenHeaders,
  ];
  let headerForLists = [
    ...segmentHeader,
    { header: "Goal Name", key: "goal_name" },
    { header: "Goal Value", key: "goal_value" },
    ...hiddenHeaders,
  ];

  let processedRows: BudgetIntakeRowInternalExcel[] = [];
  for (let row of rows) {
    const customSegmentObject = customSegmentList.reduce((acc, key) => {
      acc[key] = row[key];
      return acc;
    }, {});

    const finalRow = {
      id: row.id,
      company: row.company,
      start_date: row.start_date,
      end_date: row.end_date,
      ...customSegmentObject,
      goal_name: row.goal_name,
      goal_value: row.goal_value,
      source: row.source,
      kpi: row.kpi,
      campaign_platform: row.campaign_platform,
    };
    processedRows.push(finalRow);
  }

  worksheet.columns = headerRowOptions;

  worksheet.addRows(processedRows);

  const listsWorksheet = workbook.addWorksheet("Lists");
  listsWorksheet.state = "hidden";
  listsWorksheet.columns = headerForLists;
  const fixedOrder = ["goalNameOptions", "goalValue", "Kpi", "Source", "Campaign (Platform)"];

  const sortedKeys = [
    ...customSegmentList
      .filter(key => !fixedOrder.includes(key))
      .sort((a, b) => a.toLowerCase().localeCompare(b.toLowerCase())),
    ...fixedOrder,
  ];

  for (let col = 0; col < sortedKeys.length; col++) {
    const key = sortedKeys[col];

    if (key === "goalValue") {
      continue;
    }
    const listOfOptions = budgetIntakeSelectorOptionsPull[key].map(obj => obj.value);

    listOfOptions.forEach((option, i) => {
      const rowObj = listsWorksheet.getRow(i + 2);
      rowObj.getCell(col + 1).value = option;
    });
  }

  for (let col = 0; col < sortedKeys.length; col++) {
    const key = sortedKeys[col];
    if (key === "goalValue") {
      continue;
    }

    const listOfOptions =
      (budgetIntakeSelectorOptionsPull[key] &&
        budgetIntakeSelectorOptionsPull[key].map(obj => obj.value)) ||
      [];
    if (listOfOptions.length === 0) {
      continue;
    }

    const listColumnLetter = excelColumnLetters[col];

    const targetColumn = col + 4;
    const startRow = 2;
    const endRow = listOfOptions.length;

    const formulaRange = `Lists!$${listColumnLetter}$${startRow}:$${listColumnLetter}$${endRow}`;

    for (let row = 2; row < 1000; row++) {
      const excelRow = worksheet.getRow(row);
      excelRow.getCell(targetColumn).dataValidation = {
        type: "list",
        allowBlank: true,
        formulae: [formulaRange],
      };
    }
  }

  const buffer = await workbook.xlsx.writeBuffer();

  const blob = new Blob([buffer], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });

  const link = document.createElement("a");
  link.href = window.URL.createObjectURL(blob);
  link.download = `${company}.xlsx`;

  document.body.appendChild(link);

  link.click();

  document.body.removeChild(link);
};

export const exportToExcel = (
  rows: BudgetIntakeRowInternalExcel[],
  company: string,
  customSegmentList: string[]
): void => {
  let processedRows: BudgetIntakeRowInternalExcel[] = [];
  const segmentHeader = customSegmentList.reduce((acc, key) => {
    acc[key] = "";
    return acc;
  }, {});

  const headerRowOptions = [
    {
      ...{ id: "", start_date: "", end_date: "" },
      ...segmentHeader,
      ...{ goal_name: "", goal_value: "" },
    },
  ];

  for (let row of rows) {
    const customSegmentObject = customSegmentList.reduce((acc, key) => {
      acc[key] = row[key];
      return acc;
    }, {});

    const finalRow = {
      id: row.id,
      company: row.company,
      start_date: row.start_date,
      end_date: row.end_date,
      ...customSegmentObject,
      goal_name: row.goal_name,
      goal_value: row.goal_value,
      source: row.source,
      kpi: row.kpi,
      campaign_platform: row.campaign_platform,
    };
    processedRows.push(finalRow);
  }

  let fileName = `${company}.xlsx`;

  // The sheet name can't exceed 31 characters.
  if (fileName.length > 31) {
    let diff = fileName.length - 31;
    fileName = fileName.substring(diff);
  }

  let worksheet =
    processedRows.length > 0
      ? XLSX.utils.json_to_sheet(processedRows)
      : XLSX.utils.json_to_sheet(headerRowOptions);

  let workbook: XLSX.WorkBook = { SheetNames: [], Sheets: {} };

  workbook.SheetNames.push(fileName);
  workbook.Sheets[fileName] = worksheet;

  XLSX.writeFile(workbook, fileName);
};

const mapArrayValue = (rawValue: any, acc: Record<string, any>, key: string) => {
  if (typeof rawValue === "string") {
    const trimmedVal = rawValue.trim();
    if (trimmedVal.startsWith("[") && trimmedVal.endsWith("]")) {
      try {
        acc[key] = JSON.parse(trimmedVal);
      } catch (e) {
        throw new Error(`Error parsing JSON for ${key}: ${e}`);
      }
    } else if (trimmedVal.includes(",")) {
      acc[key] = trimmedVal.split(",").map(item => item.trim());
    } else {
      acc[key] = [trimmedVal];
    }
  } else if (Array.isArray(rawValue)) {
    acc[key] = rawValue;
  } else {
    acc[key] = rawValue != null ? [rawValue] : null;
  }
};

const mapRowToDisplay = (row: any, companyNew: string, customSegmentList: string[]) => {
  const { company, lastmodified } = row;
  const id = row.id || row.ID;
  const startDate =
    row.start_date ||
    row["Start Date"] ||
    row[" Start Date "] ||
    row["start date"] ||
    row[" start date "];
  const endDate =
    row.end_date || row["End Date"] || row[" End Date "] || row["end date"] || row[" end date "];
  const goalName =
    row.goal_name ||
    row["Goal Name"] ||
    row[" Goal Name "] ||
    row["goal name"] ||
    row[" goal name "];
  const goalValue =
    row.goal_value ||
    row["Goal Value"] ||
    row[" Goal Value "] ||
    row["goal value"] ||
    row[" goal value "];
  const campaignPlatform =
    row.campaign_platform ||
    row["Campaign (Platform)"] ||
    row[" Campaign (Platform) "] ||
    row["campaign platform"] ||
    row[" campaign platform "];

  const startHead = {
    id: id,
    company: company ? company : companyNew,
    start_date: isOnlyDigits(startDate) ? excelNumberToDate(startDate) : startDate,
    end_date: isOnlyDigits(endDate) ? excelNumberToDate(endDate) : endDate,
  };
  const endHead = {
    goal_name: goalName,
    goal_value: Math.round(goalValue),
    lastmodified: lastmodified ? lastmodified : Dfns.format("yyyy-MM-dd hh:mma", new Date()),
  };
  const newRow = { ...startHead, ...endHead };
  mapArrayValue(campaignPlatform, newRow, "campaign_platform");
  const arraySegments = ["Channel"]; // Add to this list if segment is allowed to have multiple values
  const combinedObject = customSegmentList.reduce(
    (acc, key) => {
      if (key in row) {
        let rawValue = row[key];

        if (arraySegments.includes(key)) {
          mapArrayValue(rawValue, acc, key);
        } else {
          acc[key] = rawValue;
        }
      } else {
        acc[key] = null;
      }
      return acc;
    },
    { ...newRow }
  );
  return combinedObject;
};

export const excelNumberToDate = (date: number): string => {
  const excelSerialNumber = date;
  const excelBaseDate = new Date(1899, 11, 30);
  const dateNew = new Date(excelBaseDate.getTime() + excelSerialNumber * 24 * 60 * 60 * 1000);
  const newFormattedDate = `${dateNew.getFullYear()}-${(dateNew.getMonth() + 1)
    .toString()
    .padStart(2, "0")}-${dateNew.getDate().toString().padStart(2, "0")}`;
  return newFormattedDate;
};

export const isOnlyDigits = (date: string): boolean => {
  const isNum = /^\d+$/.test(date);
  return isNum;
};

const checkRowIsValid = (
  row: any,
  customSegmentList: string[],
  currentRowNumberInExcel: number
) => {
  const { start_date, end_date, goal_name, goal_value } = row;
  const missingFields: string[] = [];
  if (!start_date) {
    missingFields.push("Start Date");
  }
  if (!end_date) {
    missingFields.push("End Date");
  }
  if (!goal_name) {
    missingFields.push("Goal Name");
  }
  if (!goal_value) {
    missingFields.push("Goal Value");
  }

  const hasAtLeastOneSegment = customSegmentList.some(segment => row[segment] != null);
  if (!hasAtLeastOneSegment) {
    missingFields.push("at least one segment");
  }
  if (missingFields.length > 0) {
    throw new Error(
      `Row ${currentRowNumberInExcel + 1} is invalid. Missing fields: ${missingFields.join(
        ", "
      )}. Please ensure all required fields are filled.`
    );
  }

  const startDate = new Date(start_date);
  const endDate = new Date(end_date);
  if (startDate > endDate) {
    throw new Error("End Date should not be before start date");
  }
  return true;
};

const checkRowIsDiff = (oldRow: any, newRow: any, customSegmentList: string[]) => {
  Object.entries(newRow).forEach(([key, value]) => {
    if (value === undefined) {
      newRow[key] = null;
    }
  });
  customSegmentList.forEach(segment => {
    oldRow[segment] = oldRow[segment] || null;
    newRow[segment] = newRow[segment] || null;
  });

  let isSegmentUpdated = customSegmentList.some(segment => oldRow[segment] !== newRow[segment]);
  if (
    oldRow.company !== newRow.company ||
    oldRow.start_date !== newRow.start_date ||
    oldRow.end_date !== newRow.end_date ||
    isSegmentUpdated ||
    oldRow.goal_name !== newRow.goal_name ||
    oldRow.goal_value !== newRow.goal_value
  ) {
    return true;
  }
  return false;
};

const checkRowIsUnique = (
  oldMap: Record<string, any>,
  newRow: any,
  customSegmentList: string[]
) => {
  let isSegmentUpdated = false;
  for (let oldRow of Object.values(oldMap)) {
    customSegmentList.forEach(segment => {
      oldRow[segment] = oldRow[segment] || null;
      newRow[segment] = newRow[segment] || null;
    });

    isSegmentUpdated = customSegmentList.some(segment => oldRow[segment] !== newRow[segment]);
    if (
      oldRow.start_date === newRow.start_date &&
      oldRow.end_date === newRow.end_date &&
      !isSegmentUpdated &&
      oldRow.goal_name === newRow.goal_name
    ) {
      return false;
    }
  }
  return true;
};

const makeKey = (row: any, customSegmentList: string[]) => {
  const segPart = customSegmentList.map(k => JSON.stringify(row[k] ?? null)).join("|");
  return [row.start_date, row.end_date, row.goal_name, row.goal_value, segPart].join("||");
};

const removeDuplicates = (existingRows: BudgetIntakeRowInternal[], customSegmentList: string[]) => {
  const originalRows: BudgetIntakeRowInternal[] = [];
  const rowsSeen = new Set<string>();
  for (let row of existingRows) {
    let currentKey = makeKey(row, customSegmentList);
    if (rowsSeen.has(currentKey)) {
      continue;
    } else {
      originalRows.push(row);
      rowsSeen.add(currentKey);
    }
  }
  return originalRows;
};

export const processBulkImport = (
  file: ArrayBuffer,
  existingRows: BudgetIntakeRowInternal[],
  companyNew: string,
  customSegmentList: string[]
): BudgetIntakeRowInternal[] => {
  let updateRowsMap: Record<string, any> = {};
  let originalRowsMap: Record<string, any> = {};

  for (let row of existingRows) {
    if (row.id) {
      updateRowsMap[row.id] = row;
      originalRowsMap[row.id] = row;
    }
  }

  // Create a workbook using the imported file.
  const workbook = XLSX.read(file, { type: "buffer" });

  // Get first sheet of workbook
  const worksheetName = workbook.SheetNames[0];
  const worksheet = workbook.Sheets[worksheetName];

  // Convert worksheet to JSON
  const rows: Record<string, any>[] = XLSX.utils.sheet_to_json(worksheet);
  let importRows: any[] = [];
  let currentRowNumberInExcel = 1;
  for (let row of rows) {
    const newRow = mapRowToDisplay(row, companyNew, customSegmentList);
    checkRowIsValid(newRow, customSegmentList, currentRowNumberInExcel);
    currentRowNumberInExcel++;
    if (newRow && !newRow.id && checkRowIsUnique(originalRowsMap, newRow, customSegmentList)) {
      importRows.push(newRow);
    } else if (
      newRow.id in updateRowsMap &&
      newRow &&
      checkRowIsDiff(updateRowsMap[newRow.id], newRow, customSegmentList)
    ) {
      importRows.push(newRow);
    }
  }
  const originalRows = removeDuplicates(importRows, customSegmentList);
  return originalRows;
};
